import React, { useState, useEffect } from 'react';

const ScrambleNumber = ({
  value,
  scrambleSpeed = 50,
  hideIfValueIsZero = false,
}) => {
  const [displayValue, setDisplayValue] = useState('0');
  const finalValue = String(value);
  const shouldHide = hideIfValueIsZero && (value === 0 || value === '0');

  useEffect(() => {
    let intervalId;

    // If value is undefined, keep scrambling
    if (value === undefined) {
      intervalId = setInterval(() => {
        // Generate a random number between 3-6 digits
        const length = 3;
        const scrambled = Array(length)
          .fill(0)
          .map(() => Math.floor(Math.random() * 10))
          .join('');
        setDisplayValue(scrambled);
      }, scrambleSpeed);
    } else {
      // Once we have a value, set it immediately
      setDisplayValue(finalValue);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [value, scrambleSpeed, finalValue]);

  if (shouldHide) {
    return null;
  }

  return <>{displayValue}</>;
};

export default ScrambleNumber;
